import React from 'react';

const AccessControlMockup = () => {
  return (
    <div className="mockup-container access-control">
      <div className="mockup-header-bar">
        <div className="mockup-title">Control de Acceso en Tiempo Real</div>
        <div className="mockup-status-dot active"></div>
      </div>
      <div className="mockup-grid-main">
        {/* Left Column: List of recent entries */}
        <div className="mockup-list-card">
          <div className="mockup-list-item">
            <div className="avatar-circle">JD</div>
            <div className="item-text">
              <span className="name">Juan Delgado</span>
              <span className="time">Entrada: 18:42</span>
            </div>
            <span className="badge-valid">VALIDADO</span>
          </div>
          <div className="mockup-list-item">
            <div className="avatar-circle">MG</div>
            <div className="item-text">
              <span className="name">María García</span>
              <span className="time">Entrada: 18:35</span>
            </div>
            <span className="badge-valid">VALIDADO</span>
          </div>
          <div className="mockup-list-item warning">
            <div className="avatar-circle">RP</div>
            <div className="item-text">
              <span className="name">Roberto Pérez</span>
              <span className="time">Intento: 18:30</span>
            </div>
            <span className="badge-expired">CADUCADO</span>
          </div>
        </div>

        {/* Right Column: Stats & QR Simulation */}
        <div className="mockup-side-stats">
          <div className="stat-box">
            <span className="stat-label">Aforo Actual</span>
            <span className="stat-val">42 / 100</span>
            <div className="progress-bg"><div className="progress-fill" style={{width: '42%'}}></div></div>
          </div>
          <div className="qr-box">
            <div className="qr-sim">
              <div className="qr-line"></div>
              <div className="qr-line"></div>
              <div className="qr-line"></div>
            </div>
            <span className="qr-label">ESCANEAR ACCESO</span>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .mockup-container {
          width: 100%;
          min-height: 350px;
          background: #ffffff;
          border-radius: 12px;
          padding: 24px;
          font-family: sans-serif;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .mockup-header-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #f3f4f6;
          padding-bottom: 12px;
        }
        .mockup-title { font-weight: 700; color: #111827; }
        .mockup-status-dot { width: 10px; height: 10px; border-radius: 50%; }
        .mockup-status-dot.active { background: #059669; box-shadow: 0 0 8px #10b981; }
        
        .mockup-grid-main { display: grid; grid-template-columns: 1fr 200px; gap: 20px; }
        
        .mockup-list-card { display: flex; flex-direction: column; gap: 12px; }
        .mockup-list-item { 
          display: flex; align-items: center; gap: 12px; 
          padding: 12px; background: #f9fafb; border-radius: 8px; border: 1px solid #e5e7eb;
        }
        .mockup-list-item.warning { border-color: #fecaca; background: #fff1f1; }
        
        .avatar-circle { 
          width: 32px; height: 32px; background: #e5e7eb; border-radius: 50%; 
          display: flex; align-items: center; justify-content: center; font-size: 10px; font-weight: 700;
        }
        .item-text { flex: 1; display: flex; flex-direction: column; }
        .item-text .name { font-size: 13px; font-weight: 600; }
        .item-text .time { font-size: 11px; color: #6b7280; }
        
        .badge-valid { font-size: 9px; font-weight: 700; color: #059669; padding: 2px 6px; background: #ecfdf5; border-radius: 4px; }
        .badge-expired { font-size: 9px; font-weight: 700; color: #dc2626; padding: 2px 6px; background: #fef2f2; border-radius: 4px; }
        
        .stat-box { background: #111827; color: white; padding: 16px; border-radius: 12px; display: flex; flex-direction: column; gap: 8px; }
        .stat-label { font-size: 11px; opacity: 0.7; }
        .stat-val { font-size: 18px; font-weight: 700; }
        .progress-bg { height: 4px; background: #374151; border-radius: 2px; }
        .progress-fill { height: 100%; background: #059669; border-radius: 2px; }
        
        .qr-box { 
          margin-top: 12px; display: flex; flex-direction: column; align-items: center; gap: 10px;
          padding: 20px; border: 2px dashed #e5e7eb; border-radius: 12px;
        }
        .qr-sim { width: 60px; height: 60px; background: #f3f4f6; display: flex; flex-direction: column; gap: 4px; padding: 10px; border-radius: 4px; }
        .qr-line { height: 4px; background: #d1d5db; border-radius: 2px; }
        .qr-label { font-size: 10px; font-weight: 700; color: #9ca3af; }
      `}} />
    </div>
  );
};

export default AccessControlMockup;
